import CohortCard from './CohortCard'
export default CohortCard
